import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getVideoById } from '../../services/VideoService';
import { Video } from '../../types/Videos';
import { FeaturesManagement } from '../../../featuresControl';

function useGetVideoById(id: string, fleetId: string, allowedToFetch: boolean = true): UseQueryResult<Video> {
  return useQuery(
    ['video', id, fleetId],
    async (): Promise<Video> => getVideoById(id, fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled: allowedToFetch,
    },
  );
}

export default useGetVideoById;
